// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.

import Rails from "@rails/ujs"
import "@hotwired/turbo-rails"
import * as ActiveStorage from "@rails/activestorage"

Rails.start()
ActiveStorage.start()

// React setup for component rendering
// Support component names relative to this directory:
var componentRequireContext = require.context("components", true);
var ReactRailsUJS = require("react_ujs");
ReactRailsUJS.useContext(componentRequireContext);
// react_ujs 2.7 predates Turbo and only auto-detects Turbolinks, so without this
// it falls back to DOMContentLoaded and components stop mounting on Turbo visits.
// Mount on turbo:load, mirroring the turbolinks:load binding it used before.
// turbo:render is also needed: failed form submissions (422 re-renders) swap the
// body WITHOUT firing turbo:load, and FlashMessage/other components must mount
// there too. Re-mounting an already-mounted node is a no-op update, so the
// double fire (render then load) on normal visits is harmless.
ReactRailsUJS.handleEvent("turbo:load", ReactRailsUJS.handleMount);
ReactRailsUJS.handleEvent("turbo:render", ReactRailsUJS.handleMount);
